const appVer = `v4.0.5.20`;

import './signozInstrument';
import {isProxy, toRaw} from 'vue';
import {UAParser} from 'ua-parser-js';
import {logs, SeverityNumber} from '@opentelemetry/api-logs';
import {context, trace} from '@opentelemetry/api';

const logger = logs.getLogger('safeapp-vue-logger');

import {createApp} from 'vue';
import App from './App.vue';
import AddToHomescreen from '@owliehq/vue-addtohomescreen';
import './registerServiceWorker';
import router from './router';
import store from './store';

import Q from 'q';
import _ from 'lodash';
import axios from "axios";
import {DateTime} from "luxon";
import ApexCharts from 'apexcharts';

import shortNumber from 'short-number';

import VueViewer from 'v-viewer';

import {createVfm} from 'vue-final-modal';
import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {fas} from '@fortawesome/free-solid-svg-icons';
import {far} from '@fortawesome/free-regular-svg-icons';
import {fab} from '@fortawesome/free-brands-svg-icons';
import Vue3FormWizard from 'vue3-form-wizard';
import Vue3EasyDataTable from 'vue3-easy-data-table';
import Datepicker from 'vuejs3-datepicker';

import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';


import 'vue3-form-wizard/dist/style.css';
import 'bulma-checkbox/css/main.min.css';
import 'bulma-radio/css/main.min.css';
import 'vue3-easy-data-table/dist/style.css';
import 'vue-final-modal/style.css';

const format = require('format-number');


library.add(fas, far, fab);


require('./styles/bulma-styles.scss');
require('./styles/fancy-check-radios.scss');
require('./styles/pictureInputSliders.scss');
require('flag-icons/css/flag-icons.min.css');

require('viewerjs/dist/viewer.css');

require('./styles/preview-checkbox.css');
require('./styles/thumbs-up.css');
require('./styles/progress-overlay.scss');
require('./styles/switch-button.scss');
require('./styles/safeapp.css');

if (process.env.VUE_APP_API_BASE_URL) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
} else if (location.host === 'safeapp.myamh.org') {
    axios.defaults.baseURL = 'https://safeappnode.myamh.org';
} else {
    axios.defaults.baseURL = 'https://safedevnode.myamh.org';
}

axios.interceptors.request.use(function (config) {
    config.headers.appVer = appVer;
    return config
});

const vfm = createVfm();


createApp(App)
    .mixin({
        data() {
            return {}
        },
        computed: {
            getLogsMetadata: function () {
                let logDetail = {};
                const storedAccount = localStorage.getItem('account');
                const parser = new UAParser();
                const result = parser.getResult();

                if (storedAccount) {
                    const account = JSON.parse(storedAccount);
                    let partnerArray = [];
                    if (account.role === 'Coordinator') {
                        for (const partner of account.partners) {
                            partnerArray.push(`${partner.partner_shortname}`);
                        }
                    }
                    if (account.role === 'Representative') {
                        partnerArray.push(`${account.partner_shortname}`)
                    }
                    logDetail = {
                        userId: account.uid.toString() || 'Not Found',
                        userRole: account.role || 'Not Found',
                        userPartner: partnerArray.join(', ') || 'Not Found',
                        userName: account.fname || 'Not Found',
                        appVer: appVer,
                        browserName: result.browser.name || '',
                        browserVersion: result.browser.version || '',
                        userAgent: result.ua || '',
                    };
                } else {
                    logDetail = {
                        userId: 'None',
                        userRole: 'None',
                        userPartner: 'None',
                        userName: 'None',
                        appVer: appVer,
                        browserName: result.browser.name || '',
                        browserVersion: result.browser.version || '',
                        userAgent: result.ua || '',
                    };
                }
                return logDetail;
            }
        },
        methods: {
            logToSignoz: function (body, attrs = {}, SeverityNumberText = 'ERROR') {
                let vm = this;
                const span = trace.getSpan(context.active());
                let traceId;
                let spanId;
                if (span) {
                    const spanContext = span.spanContext();
                    traceId = spanContext.traceId;
                    spanId = spanContext.spanId;
                }

                logger.emit({
                    body,
                    severityNumber: SeverityNumber[SeverityNumberText],
                    severityText: SeverityNumberText,
                    attributes: _.merge({}, vm.getLogsMetadata, attrs, {trace_id: traceId, span_id: spanId}),
                });
            },
            saveToIDB: async function (responseDatas, storeName, clearDB) {
                let vm = this;
                let rawResponseData,
                    storeDataObj;
                if (clearDB) {
                    await vm.clearPatientsFromDb(vm.IDB, storeName);
                }
                const storedAccount = localStorage.getItem("account");
                let storedAccountPartnerId;
                if (storedAccount) {
                    storedAccountPartnerId = JSON.parse(storedAccount).partnerid;
                }
                vm.$_.forEach(responseDatas, async function (responseData) {
                    if (isProxy(responseData)) {
                        rawResponseData = toRaw(responseData);
                    } else {
                        rawResponseData = responseData
                    }
                    switch (storeName) {
                        case 'draftProfiles':
                            storeDataObj = {
                                id: parseInt(vm.$_.split(rawResponseData.profileIdentifier, '-')[1]),
                                caseId: rawResponseData.profileIdentifier,
                                caseData: rawResponseData,
                                dirtyState: false,
                                partnerId: storedAccountPartnerId
                            }
                            break;
                        case 'unapprovedProfiles':
                            storeDataObj = {
                                id: parseInt(vm.$_.split(rawResponseData.profileIdentifier, '-')[1]),
                                caseId: rawResponseData.profileIdentifier,
                                caseData: rawResponseData,
                                dirtyState: false,
                                partnerId: rawResponseData.partnerid
                            }
                            break;
                        case 'approvedProfiles':
                            storeDataObj = {
                                id: parseInt(vm.$_.split(rawResponseData.profileIdentifier, '-')[1]),
                                caseId: rawResponseData.profileIdentifier,
                                caseData: rawResponseData,
                                dirtyState: false,
                                partnerId: rawResponseData.partnerid
                            }
                            break;
                        case 'returnedProfiles':
                            storeDataObj = {
                                id: parseInt(vm.$_.split(rawResponseData.profileIdentifier, '-')[1]),
                                caseId: rawResponseData.profileIdentifier,
                                caseData: rawResponseData,
                                dirtyState: false,
                                partnerId: rawResponseData.partnerid
                            }
                            break;
                        case 'rejectedProfiles':
                            storeDataObj = {
                                id: parseInt(vm.$_.split(rawResponseData.profileIdentifier, '-')[1]),
                                caseId: rawResponseData.profileIdentifier,
                                caseData: rawResponseData,
                                dirtyState: false,
                                partnerId: rawResponseData.partnerid
                            }
                            break;
                        case 'draftFeedbacks':
                            storeDataObj = {
                                id: parseInt(vm.$_.split(rawResponseData.profileIdentifier, '-')[1]),
                                caseId: rawResponseData.profileIdentifier,
                                caseData: rawResponseData,
                                dirtyState: false,
                                partnerId: storedAccountPartnerId
                            }
                            break;
                        case 'unapprovedFeedbacks':
                            storeDataObj = {
                                id: parseInt(vm.$_.split(rawResponseData.Identifier, '-')[1]),
                                caseId: rawResponseData.Identifier,
                                caseData: rawResponseData,
                                dirtyState: false,
                                partnerId: rawResponseData.profile.partnerid
                            }
                            break;
                        case 'returnedFeedbacks':
                            storeDataObj = {
                                id: parseInt(vm.$_.split(rawResponseData.Identifier, '-')[1]),
                                caseId: rawResponseData.Identifier,
                                caseData: rawResponseData,
                                dirtyState: false,
                                partnerId: rawResponseData.profile.partnerid
                            }
                            break;
                        case 'closedFeedbacks':
                            storeDataObj = {
                                id: parseInt(vm.$_.split(rawResponseData.Identifier, '-')[1]),
                                caseId: rawResponseData.Identifier,
                                caseData: rawResponseData,
                                dirtyState: false,
                                partnerId: rawResponseData.profile.partnerid
                            }
                            break;
                        case 'invoiceFeedbacks':
                            storeDataObj = {
                                id: parseInt(vm.$_.split(rawResponseData.Identifier, '-')[1]),
                                caseId: rawResponseData.Identifier,
                                caseData: rawResponseData,
                                dirtyState: false,
                                partnerId: rawResponseData.profile.partnerid
                            }
                            break;
                        case 'remittanceFeedbacks':
                            storeDataObj = {
                                id: parseInt(vm.$_.split(rawResponseData.Identifier, '-')[1]),
                                caseId: rawResponseData.Identifier,
                                caseData: rawResponseData,
                                dirtyState: false,
                                partnerId: rawResponseData.partnerId
                            }
                            break;
                    }
                    try {
                        return await vm.addPatientToDb(vm.IDB, storeName, storeDataObj);
                    } catch (err) {
                        console.error(err);
                        return false;
                    }
                });
            },
            fetchFromIDB: async function (storeName) {
                let vm = this;
                let dataKey;
                switch (storeName) {
                    case 'draftProfiles':
                        dataKey = 'caseData';
                        break;
                    case 'unapprovedProfiles':
                        dataKey = 'caseData';
                        break;
                    case 'approvedProfiles':
                        dataKey = 'caseData';
                        break;
                    case 'returnedProfiles':
                        dataKey = 'caseData';
                        break;
                    case 'rejectedProfiles':
                        dataKey = 'caseData';
                        break;
                    case 'draftFeedbacks':
                        dataKey = 'caseData';
                        break;
                    case 'unapprovedFeedbacks':
                        dataKey = 'caseData';
                        break;
                    case 'returnedFeedbacks':
                        dataKey = 'caseData';
                        break;
                    case 'closedFeedbacks':
                        dataKey = 'caseData';
                        break;
                    case 'invoiceFeedbacks':
                        dataKey = 'caseData';
                        break;
                    case 'remittanceFeedbacks':
                        dataKey = 'caseData';
                        break;
                }

                let filterForPartner = localStorage.getItem("filterForPartner");
                if (filterForPartner === 'all') {
                    return await vm.getPatientFromDb(vm.IDB, storeName, false, false, dataKey);
                } else {
                    return await vm.getPatientFromDb(vm.IDB, storeName, filterForPartner, 'partnerId', dataKey);
                }

            },
            manageDirtyList: async function (action, caseId) {
                let vm = this;
                try {
                    let caseData = _.split(caseId, '_'),
                        patientStore,
                        storeCaseId;
                    switch (action) {
                        case 'dirty':
                            if (!_.indexOf(vm.localDirtyList, caseId) >= 0) {
                                switch (caseData[0]) {
                                    case 'draftProfile':
                                        patientStore = 'draftProfiles';
                                        storeCaseId = vm.patientProfileIdentifier
                                        break;
                                    case 'submitDraftProfile':
                                        patientStore = 'draftProfiles';
                                        storeCaseId = vm.patientProfileIdentifier
                                        break;
                                    case 'returnedProfile':
                                        patientStore = 'returnedProfiles';
                                        storeCaseId = caseData[1]
                                        break;
                                }
                                let targetPatient = await vm.getPatientFromDb(vm.IDB, patientStore, storeCaseId, 'caseId', false);
                                if (targetPatient.length > 0) {
                                    await vm.putPatientToDb(vm.IDB, patientStore, _.assignIn({}, targetPatient[0], {dirtyState: true}));
                                }
                                vm.localDirtyList.push(caseId)
                                vm.localDirtyList = _.uniq(vm.localDirtyList);
                                switch (caseData[0]) {
                                    case 'draftProfile':
                                        vm.draftProfiles = await vm.fetchFromIDB('draftProfiles');
                                        break;
                                    case 'submitDraftProfile':
                                        vm.draftProfiles = await vm.fetchFromIDB('draftProfiles');
                                        break;
                                    case 'returnedProfile':
                                        vm.returnedProfiles = await vm.fetchFromIDB('returnedProfiles');
                                        break;
                                }
                            }
                            break;
                    }
                    vm.$emit('dirtLists', {
                        dirtyList: _.uniq(_.compact(vm.localDirtyList))
                    });
                } catch (error) {
                    console.error(error);
                    vm.logToSignoz('error occured in manageDirtyList', {error: error.message}, 'ERROR');
                }
            },
            createStore: function (db, storeName) {
                if (!db.objectStoreNames.contains(storeName)) {
                    db.createObjectStore(storeName, {
                        keyPath: 'id'
                    });
                } else {
                    db.deleteObjectStore(storeName);
                    db.createObjectStore(storeName, {
                        keyPath: 'id'
                    });
                }
            },
            createIndex: function (req, storeName, indexDetails) {
                let trans = req.transaction;
                let store = trans.objectStore(storeName);
                _.forEach(indexDetails, function (indexDetail) {
                    if (!store.indexNames.contains(indexDetail.indexName)) {
                        store.createIndex(indexDetail.indexName, indexDetail.indexName, {unique: indexDetail.indexUnique});
                    }
                });
            },
            getIDB: async function () {
                let vm = this;
                return new Promise(function (resolve, reject) {
                    try {
                        let appVerParts = _.split(appVer, '.');
                        let DBVersion = parseInt(appVerParts[appVerParts.length - 1]);
                        let request = window.indexedDB.open('safeApp-db', DBVersion);
                        request.onerror = function (error) {
                            console.error('Error opening db', error);
                            vm.logToSignoz('error occured in getIDB', {error: error.message}, 'ERROR');
                            reject('Error');
                        };
                        request.onsuccess = function (e) {
                            let db = e.target.result;
                            resolve(db);
                        };
                        request.onupgradeneeded = function (e) {
                            let req = e.target;
                            let db = e.target.result;

                            vm.createStore(db, 'draftProfiles');
                            vm.createStore(db, 'unapprovedProfiles');
                            vm.createStore(db, 'approvedProfiles');
                            vm.createStore(db, 'returnedProfiles');
                            vm.createStore(db, 'rejectedProfiles');

                            vm.createStore(db, 'draftFeedbacks');
                            vm.createStore(db, 'unapprovedFeedbacks');
                            vm.createStore(db, 'returnedFeedbacks');
                            vm.createStore(db, 'closedFeedbacks');
                            vm.createStore(db, 'invoiceFeedbacks');
                            vm.createStore(db, 'remittanceFeedbacks');


                            vm.createIndex(req, 'draftProfiles', [
                                {indexName: 'caseId', indexUnique: true},
                                {indexName: 'dirtyState', indexUnique: false},
                                {indexName: 'partnerId', indexUnique: false}
                            ]);

                            vm.createIndex(req, 'unapprovedProfiles', [
                                {indexName: 'caseId', indexUnique: true},
                                {indexName: 'dirtyState', indexUnique: false},
                                {indexName: 'partnerId', indexUnique: false}
                            ]);

                            vm.createIndex(req, 'approvedProfiles', [
                                {indexName: 'caseId', indexUnique: true},
                                {indexName: 'dirtyState', indexUnique: false},
                                {indexName: 'partnerId', indexUnique: false}
                            ]);

                            vm.createIndex(req, 'returnedProfiles', [
                                {indexName: 'caseId', indexUnique: true},
                                {indexName: 'dirtyState', indexUnique: false},
                                {indexName: 'partnerId', indexUnique: false}
                            ]);

                            vm.createIndex(req, 'rejectedProfiles', [
                                {indexName: 'caseId', indexUnique: true},
                                {indexName: 'dirtyState', indexUnique: false},
                                {indexName: 'partnerId', indexUnique: false}
                            ]);

                            vm.createIndex(req, 'draftFeedbacks', [
                                {indexName: 'caseId', indexUnique: true},
                                {indexName: 'dirtyState', indexUnique: false},
                                {indexName: 'partnerId', indexUnique: false}
                            ]);

                            vm.createIndex(req, 'unapprovedFeedbacks', [
                                {indexName: 'caseId', indexUnique: true},
                                {indexName: 'dirtyState', indexUnique: false},
                                {indexName: 'partnerId', indexUnique: false}
                            ]);

                            vm.createIndex(req, 'returnedFeedbacks', [
                                {indexName: 'caseId', indexUnique: true},
                                {indexName: 'dirtyState', indexUnique: false},
                                {indexName: 'partnerId', indexUnique: false}
                            ]);

                            vm.createIndex(req, 'closedFeedbacks', [
                                {indexName: 'caseId', indexUnique: true},
                                {indexName: 'dirtyState', indexUnique: false},
                                {indexName: 'partnerId', indexUnique: false}
                            ]);

                            vm.createIndex(req, 'invoiceFeedbacks', [
                                {indexName: 'caseId', indexUnique: true},
                                {indexName: 'dirtyState', indexUnique: false},
                                {indexName: 'partnerId', indexUnique: false}
                            ]);

                            vm.createIndex(req, 'remittanceFeedbacks', [
                                {indexName: 'caseId', indexUnique: true},
                                {indexName: 'dirtyState', indexUnique: false},
                                {indexName: 'partnerId', indexUnique: false}
                            ]);
                        };
                    } catch (error) {
                        console.error('Error opening db', error);
                        vm.logToSignoz('error occured in getIDB', {error: error.message}, 'ERROR');
                        reject('Error');
                    }
                });
            },
            addPatientToDb: async function (IDB, patientStore, patientData) {
                let vm = this;
                return new Promise(function (resolve, reject) {
                    if (!IDB.objectStoreNames.contains(patientStore)) {
                        vm.createStore(IDB, patientStore);
                        resolve();
                    } else {
                        let trans = IDB.transaction([patientStore], 'readwrite');
                        trans.oncomplete = function () {
                            resolve();
                        };
                        trans.onerror = function (error) {
                            if (error.target.error.message === 'Key already exists in the object store.') {
                                console.log(`adding patient to ${patientStore}: duplicate patient: ${patientData.caseId}`);
                                vm.logToSignoz(`duplicate patient: ${JSON.stringify(patientData)}`, {error: error.message}, 'ERROR');
                                resolve();
                            } else {
                                console.error('Error adding patient to db', error);
                                console.error(error.target);
                                console.error(error.target.error);
                                console.error(patientData);
                                vm.logToSignoz('addPatientToDb: Error adding patient to db', {
                                    error: error.message,
                                    target: error.target,
                                    targeterror: error.target.error,
                                    patientData: patientData
                                }, 'ERROR');
                                reject('Error');
                            }

                        };
                        let store = trans.objectStore(patientStore);
                        if (typeof patientData !== 'undefined') {
                            let request = store.add(patientData);
                            request.onerror = function (error) {
                                if (error.target.error.message === 'Key already exists in the object store.') {
                                    console.log(`adding patient to ${patientStore}: duplicate patient: ${patientData.caseId}`);
                                    vm.logToSignoz(`duplicate patient: ${JSON.stringify(patientData)}`, {error: error.message}, 'ERROR');
                                    resolve();
                                } else {
                                    console.error('Error', error);
                                    console.error('Error', error.target.error.name);
                                    console.error(patientData);
                                    vm.logToSignoz('addPatientToDb: Error adding patient to db', {
                                        error: error.message,
                                        target: error.target,
                                        targeterror: error.target.error,
                                        targeterrorname: error.target.error.name,
                                        patientData: patientData
                                    }, 'ERROR');
                                    reject('Error');
                                }
                            };
                            request.onsuccess = function () {
                                resolve();
                            };
                        } else {
                            resolve();
                        }
                    }
                });
            },
            putPatientToDb: async function (IDB, patientStore, patientData) {
                let vm = this;
                return new Promise(function (resolve, reject) {
                    try {
                        let trans = IDB.transaction([patientStore], 'readwrite');
                        trans.oncomplete = function () {
                            resolve();
                        };
                        trans.onerror = function (error) {
                            console.error('Error opening db', error);
                            vm.logToSignoz('putPatientToDb: Error opening db', {
                                error: error.message,
                                target: error.target,
                                targeterror: error.target.error,
                                targeterrorname: error.target.error.name,
                                patientData: patientData
                            }, 'ERROR');
                            reject('Error');
                        };
                        let store = trans.objectStore(patientStore);
                        let request = store.put(patientData);
                        request.onerror = function (error) {
                            console.error('Error', error.target.error.name);
                            vm.logToSignoz('putPatientToDb: Error opening db', {
                                error: error.message,
                                target: error.target,
                                targeterror: error.target.error,
                                targeterrorname: error.target.error.name,
                                patientData: patientData
                            }, 'ERROR');
                        };
                        request.onsuccess = function () {
                            resolve();
                        };
                    } catch (error) {
                        console.error('Error', error);
                        vm.logToSignoz('error occured in putPatientToDb', {
                            error: error.message,
                            store: patientStore,
                            data: patientData
                        }, 'ERROR');
                        reject('Error');
                    }
                });
            },
            clearPatientsFromDb: async function (IDB, patientStore) {
                let vm = this;
                return new Promise(function (resolve, reject) {
                    if (!IDB.objectStoreNames.contains(patientStore)) {
                        vm.createStore(IDB, patientStore);
                        resolve();
                    } else {
                        let trans = IDB.transaction([patientStore], 'readwrite');
                        trans.oncomplete = function () {
                            resolve();
                        };
                        trans.onerror = function (error) {
                            console.error('Error opening db', error);
                            vm.logToSignoz('clearPatientsFromDb: Error opening db', {
                                error: error.message,
                                target: error.target,
                                targeterror: error.target.error,
                                targeterrorname: error.target.error.name,
                                patientStore: patientStore
                            }, 'ERROR');
                            reject('Error');
                        };
                        let store = trans.objectStore(patientStore);
                        let request = store.clear();
                        request.onerror = function (error) {
                            console.error('Error', error.target.error.name);
                            vm.logToSignoz('clearPatientsFromDb Error', {
                                error: error.message,
                                target: error.target,
                                targeterror: error.target.error,
                                targeterrorname: error.target.error.name,
                                patientStore: patientStore
                            }, 'ERROR');
                        };
                        request.onsuccess = function () {
                            resolve();
                        };
                    }
                });
            },
            clearAllDbStores: async function (IDB) {
                let vm = this;
                return new Promise(function (resolve) {
                    _.forEach(IDB.objectStoreNames, async function (patientStore) {
                        await vm.clearPatientsFromDb(IDB, patientStore);
                    });
                    resolve();

                });
            },
            getPatientFromDb: async function (IDB, patientStore, patientKey, useIndex, recordsKey) {
                let vm = this;
                return new Promise(function (resolve, reject) {
                    try {
                        if (typeof patientStore !== 'undefined') {
                            let trans = IDB.transaction([patientStore], 'readwrite'),
                                patientData;
                            trans.oncomplete = function () {
                                resolve(patientData);
                            };
                            trans.onerror = function (error) {
                                console.error('Error opening db', error);
                                vm.logToSignoz('getPatientFromDb Error opening db', {
                                    error: error.message,
                                    target: error.target,
                                    targeterror: error.target.error,
                                    targeterrorname: error.target.error.name,
                                    patientStore: patientStore
                                }, 'ERROR');
                                reject('Error');
                            };
                            let store;
                            if (useIndex) {
                                store = trans.objectStore(patientStore).index(useIndex);
                            } else {
                                store = trans.objectStore(patientStore);
                            }
                            let request;
                            if (patientKey) {
                                const keyRangeValue = IDBKeyRange.only(patientKey);
                                request = store.openCursor(keyRangeValue);
                            } else {
                                request = store.openCursor();
                            }


                            patientData = [];
                            request.onerror = function (error) {
                                console.error('Error', error.target.error.name);
                                vm.logToSignoz('getPatientFromDb Error', {
                                    error: error.message,
                                    target: error.target,
                                    targeterror: error.target.error,
                                    targeterrorname: error.target.error.name,
                                    patientStore: patientStore
                                }, 'ERROR');
                            };
                            request.onsuccess = (e) => {
                                let cursor = e.target.result,
                                    patientDataObject;
                                if (cursor) {
                                    patientDataObject = cursor.value;
                                    if (recordsKey) {
                                        patientData.push(_.assignIn({}, patientDataObject[recordsKey], {
                                            dirtyState: patientDataObject.dirtyState,
                                            partnerId: patientDataObject.partnerId,
                                        }));
                                    } else {
                                        patientData.push(patientDataObject);
                                    }
                                    cursor.continue();
                                } else {
                                    resolve(patientData);
                                }
                            };
                        }
                    } catch (error) {
                        console.error(error)
                        vm.logToSignoz('getPatientFromDb Error', {
                            error: error.message,
                            target: error.target,
                            targeterror: error.target.error,
                            targeterrorname: error.target.error.name,
                            patientStore: patientStore
                        }, 'ERROR');
                        reject('Error');
                    }
                });
            },
            isoToJSDate: function (isoString) {

                let isoStringParts = _.split(isoString, 'T'),
                    isoStringTimeWithZone = _.split(isoStringParts[1], '+'),
                    isoStringTimeSeconds = _.split(isoStringTimeWithZone[0], '.');

                const isoStringPartsArr = _.split(isoStringParts[0], '-'),
                    isoStringTimeSecondsArr = _.split(isoStringTimeSeconds[0], ':');
                return new Date(isoStringPartsArr[0], parseInt(isoStringPartsArr[1]) - 1, isoStringPartsArr[2], isoStringTimeSecondsArr[0], isoStringTimeSecondsArr[1], isoStringTimeSecondsArr[2], isoStringTimeSeconds[1]);
            },
            fetchCaseDetails: function (fetchCaseDetailsFrom, caseId, currentDataToken, partnerId, caseYear) {
                let vm = this;
                return new Promise(function (resolve) {
                    axios.post(`/profile/caseView`, {
                        caseId: caseId,
                        fetchCaseDetailsFrom: fetchCaseDetailsFrom,
                        partnerId: partnerId,
                        caseYear: caseYear,
                    }, {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${currentDataToken}`
                        }
                    })
                        .then(function (res) {
                            resolve(res);
                        })
                        .catch(function (error) {
                            console.error(error);
                            vm.logToSignoz('getPatientFromDb Error', {
                                error: error.message,
                                target: error.target,
                                targeterror: error.target.error,
                                targeterrorname: error.target.error.name,
                                caseId: caseId
                            }, 'ERROR');
                            resolve({});
                        });
                });

            },
            strictUrlEncode: function (string) {
                return encodeURIComponent(string)
                    .replace(/'/g, "%27");
            }
        },
    })
    .use(vfm)
    .use(store)
    .use(router)
    .use(Vue3FormWizard)
    .use(VueViewer)
    .use(PrimeVue, {
        theme: {
            preset: Aura,
            options: {
                prefix: 'p',
                darkModeSelector: 'system',
                cssLayer: false
            }
        }
    })
    .use(AddToHomescreen, {
        buttonColor: 'blue',
    })
    .component('font-awesome-icon', FontAwesomeIcon)
    .component('EasyDataTable', Vue3EasyDataTable)
    .component('Datepicker', Datepicker)
    .provide('$Q', Q)
    .provide('$_', _)
    .provide('$axios', axios)
    .provide('$formatNumber', format)
    .provide('$DateTime', DateTime)
    .provide('$ApexCharts', ApexCharts)
    .provide('$shortNumber', shortNumber)
    .provide('$appVer', appVer)
    .provide('$apiBaseURL', axios.defaults.baseURL)
    .mount('#app');
